import { useWidgetContext } from '../../../../../../Widget'
import { LISTING_PROFILE_EDIT_BLOCK } from '../../../RentalPortalListingProfile.constants'
import { useListingProfileBlockToEdit } from '../../RentalPortalListingProfileExpose.hooks'
import { RentalPortalListingProfileKeyFactsWidgetForm } from '../RentalPortalListingProfileKeyFactsWidgetForm'
import { RentalPortalListingProfileKeyFactsWidgetReadView } from '../RentalPortalListingProfileKeyFactsWidgetReadView'

function RentalPortalListingProfileKeyFactsWidgetContent({ containerRef }) {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  useListingProfileBlockToEdit({
    blockId: LISTING_PROFILE_EDIT_BLOCK.keyFacts,
    containerRef,
  })

  return isEditMode ? (
    <RentalPortalListingProfileKeyFactsWidgetForm
      onClose={handleDisableEditMode}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <RentalPortalListingProfileKeyFactsWidgetReadView />
  )
}

export default RentalPortalListingProfileKeyFactsWidgetContent
